module.exports = __webpack_public_path__ + "img/Folded_Paper_Gowallet_gif1.a47428a2.gif";